export function getStars (correct, total) {
  const percentage = correct / total
  if (percentage < 0.64) return 1
  if (percentage < 1.00) return 2
  return 3
}
